import {
  SET_AUTHENTICATED,
  SET_UNAUTHENTICATED,
  LOADER_CHECK,
  LOADER_FALSE,
  SEAT_BOOKING,
  TOTAOL_COUNT,
  SEAT_BOOKING_KPI,
  SEAT_BOOKING_GRAPH,
  SEAT_BOOKING_ALL_DATA,
} from '../type';

const initialState = {
  BookingList: [],
  loader: false,
  BookingListExport:[],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_UNAUTHENTICATED:
      return initialState;
    case SEAT_BOOKING:
      return {
        ...state,
        BookingList: { ...action?.payload, ...state?.BookingList, data: { ...state?.BookingList?.data, ...action?.payload?.data } },
        loading: false,
      };
    case SEAT_BOOKING_KPI:
      return {
        ...state,
        BookingList: { ...action?.payload, ...state?.BookingList, data: { ...state?.BookingList?.data, ...action?.payload?.data } },
        loading: false,
      };
    case SEAT_BOOKING_GRAPH:
      return {
        ...state,
        BookingList: { ...action?.payload, ...state?.BookingList, data: { ...state?.BookingList?.data, ...action?.payload?.data } },
        loading: false,
      };
    case LOADER_CHECK:
      return {
        ...state,
        loader: true,
      };
    case LOADER_FALSE:
      return {
        ...state,
        loader: false,
      };
    case SEAT_BOOKING_ALL_DATA:
      return {
        ...state,
        BookingListExport: action.payload,
      };
    case TOTAOL_COUNT:
      return {
        ...state,
        totalCount: action.payload.data.total,
        loading: false,
      };
    default:
      return state;
  }
}
